import { Anchor, Card, Divider, Stack } from '@mantine/core';
import { IconUserExclamation } from '@tabler/icons-react';
import {
  ACTIVITIES,
  type ActivityName,
  activityHtml,
} from 'app/Private/Dashboard/RecentActivities/activities';
import { i18nKeys, useTranslation } from 'locales';
import { TenantActivity } from './TenantActivity';
import { TenantCardHeader } from './TenantCardHeader';
import { TenantHeadline } from './TenantHeadline';
import type { GroupOverviewTenant } from './tenant';

const CARD_ACTIVITIES: ActivityName[] = [
  'invoicesToTreat',
  'ongoingTasksCount',
  'paymentCount',
  'unprocessedEmailsCount',
  'unreadThirdPartyMessagesCount',
  'failedRemindersCount',
  'latePaymentPlansCount',
];

type TenantCardProps = {
  tenant: GroupOverviewTenant;
  companyName: string;
  tenantUrl: string;
};

export const TenantCard = ({ tenant, companyName, tenantUrl }: TenantCardProps) => {
  const { t } = useTranslation();

  return (
    <Card component="li" aria-label={companyName} withBorder radius="lg" padding="lg">
      <TenantCardHeader companyName={companyName} />

      <Anchor
        href={`${tenantUrl}${ACTIVITIES.debtorsToHandle.path}`}
        target="_blank"
        underline="never"
      >
        <TenantHeadline
          value={tenant.debtorsToHandle}
          label={t(i18nKeys.GROUP.CLIENTS_TO_TREAT)}
          color="coral.6"
          icon={<IconUserExclamation size={20} stroke={1.7} color="var(--mantine-color-coral-6)" />}
        />
      </Anchor>

      <Divider my="md" color="gray.1" />

      <Stack gap={9}>
        {CARD_ACTIVITIES.map(name => (
          <TenantActivity
            key={name}
            count={tenant[name]}
            icon={ACTIVITIES[name].icon}
            html={activityHtml(name, tenant[name], t)}
            href={`${tenantUrl}${ACTIVITIES[name].path}`}
          />
        ))}
      </Stack>
    </Card>
  );
};
